import { useEffect, useState } from "react";
import { SidebarProvider, useSidebar } from "units/dashboard/context/SidebarProvider";
import UserSidebar from "../components/UserSidebar";
import Header from "units/dashboard/components/Header";
import Footer from "units/dashboard/components/Footer";
import NewUserDashboard from "./NewUserDahboard";

const UserDashboardInner = () => {
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024 && isSidebarOpen) {
        toggleSidebar();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isSidebarOpen, toggleSidebar]);

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gradient-to-br from-slate-50 via-white to-teal-50/40 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950">

      {/* ================= Header ================= */}
      <nav
        className="
          shrink-0 z-30 h-[70px]
          flex items-center
          border-b border-teal-500/20 dark:border-teal-400/15
          bg-white/85 dark:bg-slate-900/85
          backdrop-blur-xl
          shadow-[0_4px_30px_-12px_rgba(15,118,110,0.35)]
          dark:shadow-[0_4px_30px_-12px_rgba(0,0,0,0.7)]
          print:hidden
        "
      >
        <Header />
      </nav>

      {/* ================= Body ================= */}
      <div className="flex-1 relative overflow-hidden">

        {/* ---------- Mobile backdrop ---------- */}
        {isSidebarOpen && (
          <div
            onClick={toggleSidebar}
            className="
              lg:hidden fixed top-[70px] inset-x-0 bottom-0 z-30
              bg-slate-900/50 dark:bg-black/60
              backdrop-blur-sm
              transition-opacity duration-300
            "
            aria-hidden="true"
          />
        )}

        {/* ---------- Sidebar (همیشه fixed) ---------- */}
        <aside
          className={`
            fixed top-[70px] bottom-0
            rtl:right-0 ltr:left-0
            w-64
            z-40

            transform transition-transform duration-300 ease-out
            ${isSidebarOpen
              ? "translate-x-0"
              : "rtl:translate-x-full ltr:-translate-x-full"
            }
            lg:!translate-x-0

            rtl:border-l ltr:border-r
            border-teal-500/10 dark:border-teal-400/10
            bg-gradient-to-b from-white/95 via-teal-50/60 to-white/95
            dark:from-slate-900/95 dark:via-slate-900/98 dark:to-slate-900/95
            backdrop-blur-xl
            shadow-[0_0_40px_-10px_rgba(15,118,110,0.4)] lg:shadow-none
            print:hidden
            overflow-hidden
          `}
        >
          <UserSidebar />
        </aside>

        {/* ---------- Main content ---------- */}
        <main
          className="
            h-full flex-1 flex flex-col overflow-hidden
            lg:rtl:pr-64 lg:ltr:pl-64
          "
        >
          <div className="flex-1 overflow-y-auto">
            <div className="page-content pt-0">
              <div className="container-fluid px-3 sm:px-4 md:px-6">
                <div className="grid grid-cols-1 mb-4">
                  <div className="flex items-center justify-between">
                    <nav className="flex" aria-label="Breadcrumb"></nav>
                  </div>
                </div>

                <div
                  className="
                    relative rounded-2xl
                    bg-white/70 dark:bg-slate-900/70
                    backdrop-blur-xl
                    border border-teal-500/10 dark:border-teal-400/10
                    shadow-[0_10px_40px_-20px_rgba(15,118,110,0.35)]
                    dark:shadow-[0_10px_40px_-20px_rgba(0,0,0,0.8)]
                    p-3 sm:p-4 md:p-6
                    overflow-hidden
                  "
                >
                  <div className="pointer-events-none absolute -top-16 -right-16 h-48 w-48 rounded-full bg-amber-300/10 blur-3xl" />
                  <div className="pointer-events-none absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-teal-400/10 blur-3xl" />
                  <div className="absolute top-0 inset-x-0 h-[2px] bg-gradient-to-l from-transparent via-amber-400/70 to-transparent" />

                  <div className="relative">
                    <NewUserDashboard />
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
};

const UserDashboard = () => (
  <SidebarProvider>
    <UserDashboardInner />
  </SidebarProvider>
);

export default UserDashboard;